import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-emp-veri',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './emp-veri.component.html',
  styleUrl: './emp-veri.component.css'
})
export class EmpVeriComponent {
  constructor(private contactUsService: ContactUsService) {}

  get contentLabels() { return this.contactUsService.contentLabels; }
}
